<footer class="app-footer">
  © {{ currentYear }} DropAddy. All rights reserved.
</footer>
